import { motion, AnimatePresence } from 'framer-motion';
import { PreloginContent } from '../../hooks/useContentForBuild';
import Modal from '../modal/modal';
import useBackButton from '../../hooks/useBackButton';

type AccountUpgradedComponent = {
  content: PreloginContent | any;
  isShown: boolean;
  toggle: () => void;
  onShowLogin: () => void;
};

export default function AccountUpgraded({ content, isShown, toggle, onShowLogin }: AccountUpgradedComponent) {
  useBackButton(isShown, toggle);

  return (
    <>
      <AnimatePresence>
        {isShown && content && (
          <motion.div key="modal" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="signin">
            <Modal toggle={toggle}>
              <div className="text-center">
                <h1>{content?.accountUpgraded}</h1>
                <p>{content?.accountUpgradedDescription}</p>
                <button onClick={onShowLogin} className="cta cta--extra-wide">
                  {content?.login}
                </button>
              </div>
            </Modal>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
